export default __webpack_public_path__ + "static/media/MagnumOpus-Mixed4-Top40ExciterOn.4af7c251.mp3";